import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BackendService } from '../../core/backend.service';
import { GuidList } from '../../viewmodels/services/guild-list';

@Injectable({
  providedIn: 'root',
})
export class GenerateGuidService implements OnDestroy {

  private guidList: string[] = [];
  private unsubscribe: Subject<boolean> = new Subject();

  constructor(private backendService: BackendService) {
    this.populateGuidList();
  }

  newGuid() {
    if (this.guidList.length < 2) {
      this.populateGuidList();
    }

    return this.guidList.pop();
  }

  populateGuidList(): void {
    this.backendService.get<GuidList>(GuidList).pipe(
      takeUntil(this.unsubscribe))
      .subscribe(result => {
        if (result) {
          this.guidList = result.guids;
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

}
